(() => {
  const STORAGE_KEY = 'wearse-store-checkout-selection-v1';

  function getVisibleCartLines() {
    return Array.from(document.querySelectorAll('#main-cart-items .cart-item'))
      .map((row) => {
        const quantity = row.querySelector('.quantity__input[data-quantity-line-key]');
        return {
          line_key: String(quantity?.dataset.quantityLineKey || ''),
          variant_id: String(quantity?.dataset.quantityVariantId || ''),
          quantity: Math.max(0, Number(quantity?.value) || 0),
        };
      })
      .filter((line) => line.line_key && line.variant_id && line.quantity > 0);
  }

  function rememberCheckoutSelection() {
    const lines = getVisibleCartLines();
    if (!lines.length) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }

    const selection = {
      version: 1,
      created_at: Date.now(),
      lines,
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
    return selection;
  }

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest('a#checkout[href]');
    if (!checkout) return;
    rememberCheckoutSelection();
  });

  window.WearseCheckoutSelection = {
    storageKey: STORAGE_KEY,
    getVisibleCartLines,
    rememberCheckoutSelection,
  };
})();
